export default __webpack_public_path__ + "static/media/second.6b4f8650.png";